// extracted by mini-css-extract-plugin
export var mainLogo = "Navbar-module--main-logo--Z4-pk";
export var navItems = "Navbar-module--nav-items--wj8pK";
export var navbarContainer = "Navbar-module--navbar-container--kX48j";
export var navbarItem = "Navbar-module--navbar-item--Lzlww";